import React, { useState, useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Logo from "../home/logo.jsx";
import { Link, useNavigate } from "react-router-dom";

function Header1() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <header>
      <div className="hero1"
       style={{
        marginTop: "0",
      }}
      >
        <div className="container">
          <div
            className="hero1-bg bg-cover"
            style={{
              backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/bg/banneracceuil.jpg)`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              height: "100%",
              margin: "0",
            }}
            data-aos="fade-in"
          >
            <div className="row align-items-center text-white">
              <div className="col-lg-5" data-aos="fade-right">
                <div className="main-image">
                  {/* Image Placeholder */}
                </div>
              </div>
              <div className="col-lg-6" data-aos="fade-left">
                <div className="main-heading1">
                  <h1 className="text-anime-style-3 text-white">
                  Bienvenue sur la plateforme des acteurs de l’écosystème de l’innovation                  </h1>
                  <p className="mt-16 text-white" style={{fontSize: '1.5rem'}}>
                  Cette plateforme vise à connecter, informer et faciliter la collaboration entre les différents acteurs de l’écosystème.Que vous soyez inventeur, créateur, chercheur, entrepreneur, investisseur, ou structure de promotion de l’innovation, vous avez un espace unique pour explorer les ressources, les opportunités et les acteurs clés pour propulser vos projets.                  </p>
                </div>
              </div>
            </div>
          </div><br /><br />
          <Logo />
        </div>
      </div>
    </header>
  );
}

export default Header1;
